import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";

import reportWebVitals from "./reportWebVitals";
import { Provider as ChakraProvider } from "./components/ui/provider";
import { BrowserRouter } from "react-router-dom";
import { Provider as ReduxProvider } from "react-redux";
import { persistor, store } from "./store/store";
import { PersistGate } from "redux-persist/integration/react";
import SingleRouting from "./routes/Index";
import { Toaster } from "../src/components/ui/toaster";

const root = ReactDOM.createRoot(
  document.getElementById("cashquin") as HTMLElement,
);
root.render(
  <React.StrictMode>
    <ChakraProvider>
      <ReduxProvider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <BrowserRouter>
            <Toaster />
            <SingleRouting />
          </BrowserRouter>
        </PersistGate>
      </ReduxProvider>
    </ChakraProvider>
  </React.StrictMode>,
);

reportWebVitals();

// const AuthGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
//   const [ready, setReady] = useState(false);
//   const ran = useRef(false);

//   useEffect(() => {
//     if (ran.current) return; // StrictMode double invoke guard
//     ran.current = true;

//     (async () => {
//       try {
//         await SessionManager.bootstrap();
//       } catch {
//         // refresh failed -> user not logged in (cookies missing/expired)
//         SessionManager.clear();
//       } finally {
//         setReady(true);
//       }
//     })();
//   }, []);

//   if (!ready) return null; // loader bhi laga sakte ho
//   return <>{children}</>;
// };

// const AppRoot: React.FC = () => {
//   const { ready } = useAuthBootstrap();

//   if (!ready) return <div>Loading...</div>; // ya loader
//   return <SingleRouting />;
// };

// export default AppRoot;
